<ngx-spinner bdColor="rgba(51,51,51,0.55)"
                size="medium"
                color="#fff"
                type="line-spin-clockwise-fade"
                [fullScreen]="false">
        <p class="loading">{{'general.loading' | translate}}...</p>
</ngx-spinner>
    <div class="row pr-3 pl-3">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <h2 class="page-title" tabindex="0">{{'notification.notification_details' | translate}}</h2>
                </div>
            </div>
        </div>
            <xng-breadcrumb separator=" > ">
                <ng-container *xngBreadcrumbItem="let breadcrumb">
                    <span *ngIf="breadcrumb">
                        {{ 'breadcrumb.' + breadcrumb | translate }}
                    </span>
                </ng-container>
            </xng-breadcrumb>
    </div>
<div class="container-fluid pt-3 pb-1 pl-0 pr-0 bg-white">
    <div class = "pl-3">
    <div class="row in-review-row">
        <div class="col-12 in-review text-center" *ngIf="_notiToView.status==2">
            <strong>***{{'notification.in_review_mode' | translate}}***</strong>
        </div>
    </div>
    <div class="row">
        <div class="col-6">
            <span *ngIf="_notiToView.scheduled&&!_notiToView.modified&&_notiToView.status!=2"><strong>{{'notification.created_scheduled_by' | translate}}:</strong></span>
            <span *ngIf="!_notiToView.scheduled||_notiToView.modified||_notiToView.status==2"><strong>{{'notification.created_by' | translate}}:</strong></span>
            <div>{{_notiToView.createdFirstName}} {{_notiToView.createdLastName}}</div>
        </div>
        <div class="col-6">
            <strong>{{'notification.created_date' | translate}}:</strong>
            <div>{{functionsService.convertUTCDateToLocalDate(_notiToView.created)}}</div>
        </div>
    </div>
    <div *ngIf="_notiToView.modified" class="row">
        <div class="col-6">
            <span *ngIf="_notiToView.scheduled&&_notiToView.status!=2"><strong>{{'notification.modified_scheduled_by' | translate}}:</strong></span>
            <span *ngIf="!_notiToView.scheduled||_notiToView.status==2"><strong>{{'notification.modified_by' | translate}}:</strong></span>
            <div>{{_notiToView.modifiedFirstName}} {{_notiToView.modifiedLastName}}</div>
        </div>
        <div class="col-6">
            <strong>{{'notification.modified_date' | translate}}:</strong>
            <div>{{functionsService.convertUTCDateToLocalDate(_notiToView.modified)}}</div>
        </div>
    </div>
    <div class="row" *ngIf="_notiToView.approvedDate">
        <div class="col-6">
            <strong>{{'notification.approved_by' | translate}}:</strong>
            <div>{{_notiToView.approverFirstName}} {{_notiToView.approverLastName}}</div>
        </div>
        <div class="col-6">
            <strong>{{'notification.approved_date' | translate}}:</strong>
            <div>{{functionsService.convertUTCDateToLocalDate(_notiToView.approvedDate)}}</div>
        </div>
    </div>
    <div class="row" *ngIf="_notiToView.status==2 && _notiToView.sentDate">
        <div class="col-6">
            <strong>{{'notification.to_be_sent_by' | translate}}:</strong>
            <div>{{_notiToView.sentFirstName}} {{_notiToView.sentLastName}}</div>
        </div>
        <div class="col-6">
            <strong>{{'notification.approval_request' | translate}}:</strong>
            <div>{{functionsService.convertUTCDateToLocalDate(_notiToView.sentDate)}}</div>
        </div>
    </div>
    <div class="row">
        <div *ngIf="_notiToView.status==1&&!_notiToView.scheduled" class="col-6">
            <strong>{{'notification.sent_by' | translate}}:</strong>
            <div>{{_notiToView.sentFirstName}} {{_notiToView.sentLastName}}</div>
        </div>
        <div *ngIf="_notiToView.scheduled" class="col-6">
            <strong>{{'notification.scheduled_date' | translate}}:</strong>
            <div>{{functionsService.convertUTCDateToLocalDate(_notiToView.scheduled)}}</div>
        </div>
        <div *ngIf="_notiToView.status==1&&_notiToView.sentDate" class="col-6">
            <strong>{{'notification.sent_date' | translate}}:</strong>
            <div>{{functionsService.convertUTCDateToLocalDate(_notiToView.sentDate)}}</div>
        </div>

    </div>
    <div *ngIf="_notiToView.status==1" class="row">
        <div class="col-6">
            <strong>{{'notification.device_count' | translate}}:</strong>
            <div>{{_notiToView.deviceCount?_notiToView.deviceCount:0}}</div>
        </div>
        <div class="col-6">
            <strong>{{'notification.email_count' | translate}}:</strong>
            <div>{{_notiToView.emailCount?_notiToView.emailCount:0}}</div>
        </div>
        <div class="col-6">
            <strong>{{'notification.sms_count' | translate}}:</strong>
            <div>{{_notiToView.smsCount?_notiToView.smsCount:0}}</div>
        </div>
        <div class="col-6">
            <strong>{{'notification.voice_count' | translate}}:</strong>
            <div>{{_notiToView.voiceCallCount?_notiToView.voiceCallCount:0}}</div>
        </div>
    </div>
    <div *ngIf="_notiToView.status!=1" class="row">
        <div class="col-12">
            <strong>{{'notification.send_via' | translate}}: </strong>
            {{sendVia}}
        </div>
    </div>
    <div *ngIf="_notiToView.status==1" class="row">
        <div class="col-12">
            <strong>{{'notification.sent_via' | translate}}: </strong>
            {{sendVia}}
        </div>
    </div>
    </div>
    <hr>
    <div class = "pl-3">
    <div class="row">
        <div class="col-12">
            <strong>{{'notification.to' | translate}}: </strong>
            <div>
                  {{ functionsService.formatMultiGroupName(_notiToView.tagName) }}
            </div>
            </div>
            <div class="col-12">
                <strong>{{'notification.message' | translate}}: </strong>
                <div>{{_notiToView.message}}</div>
            </div>
        </div>
    </div>
</div>
<br>
<div class="col-12 p-0">
        <div class="d-flex flex-row bd-highlight float-left">
        <div class="bd-highlight button-group text-nowrap font-weight-bold pt-5">
        {{'notification.users' | translate}}
        </div>
    </div>
    <div class="d-flex flex-row bd-highlight float-right">
        <div class="pb-2 bd-highlight">
            <!--datasource filter-->
            <label class="mb-0" for="filter">{{'general.filter_user_table' | translate}}</label>
            <input id="filter" title="{{'general.filter_name_alert' | translate}}" class="form-control border-secondary">
        </div>
        <div class="bd-highlight button-group text-nowrap pt-4">
            <!--clear filter-->
            <button tabindex="0" class="btn remove-filter-btn ml-1" title="" (click)="clearFilter()">
                <i class="fa fa-times fa-sm" title="{{ 'general.clear_filter' | translate }}"></i>
            </button>
            <!--apply filter-->
            <button tabindex="0" class="btn apply-filter-btn ml-1" title="" (click)="applyFilter()">
                <i class="fa fa-filter fa-xs" title="{{ 'general.apply_filter' | translate }}"></i>
            </button>
        </div>
    </div>
</div>
<table class="border-top" mat-table [dataSource]="dataSource" matSort #Sort="matSort" >
    <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.name' | translate}} </th>
        <td class="text-break" mat-cell *matCellDef="let notification"> {{notification.fullName}} </td>
    </ng-container>

    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.email' | translate}} </th>
        <td mat-cell *matCellDef="let notification"> {{notification.email}} </td>
    </ng-container>

    <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.phone_number' | translate}} </th>
        <td mat-cell *matCellDef="let notification"> {{notification.phoneNumber}} </td>
    </ng-container>

    <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.role' | translate}} </th>
        <td mat-cell *matCellDef="let notification">{{ 'roles.'+notification.role | translate}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator #Paginator="matPaginator" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

    